export interface PortfolioLink {
  label: string;
  slug: string;
  href: string;
}

export const portfolioLinks: PortfolioLink[] = [
  { label: 'Veep Capital',  slug: 'veep-capital',  href: 'https://www.veepcapital.com' },
  { label: 'CapSeriesX',    slug: 'capseriesx',    href: 'https://www.veepcapital.com/capseries' },
  { label: 'DevRaise',      slug: 'devraise',      href: 'https://www.veepcapital.com/investment-types/real-estate' },
  { label: 'VruddhiX',      slug: 'vruddhix',      href: 'https://www.vruddhix.com' },
  { label: 'Nova Era Labs', slug: 'nova-era-labs', href: 'https://www.novaeralabs.us' },
  { label: 'OmniHealthX',   slug: 'omnihealthx',   href: 'https://www.omnihealthx.com' },
  { label: 'Pixentro',      slug: 'pixentro',      href: 'https://www.pixentro.com' },
];

const portfolioLinkMap = new Map(
  portfolioLinks.flatMap((link) => [
    [link.label.toLowerCase(), link.href] as const,
    [link.slug.toLowerCase(), link.href] as const,
  ])
);

export function getPortfolioBrandUrl(brand: { name?: string; slug?: string; externalUrl?: string }) {
  if (brand.externalUrl) {
    return brand.externalUrl;
  }

  if (brand.slug) {
    const slugUrl = portfolioLinkMap.get(brand.slug.toLowerCase());
    if (slugUrl) {
      return slugUrl;
    }
  }

  if (brand.name) {
    return portfolioLinkMap.get(brand.name.toLowerCase());
  }

  return undefined;
}
